/* BUBBO behaviors (window.Bubbo). Owner: WP1. No deps, no window scroll/resize listeners, no idle rAF.
   Event names = @shopify/events StandardEvents values, as strings (no CDN import to fail). */
(() => {
  if (window.Bubbo) return;
  const doc = document;
  const root = doc.documentElement;
  const cls = root.classList;
  const EV_SELECT = 'shopify:product:select';
  const EV_LINES = 'shopify:cart:lines-update';

  cls.add('bb-js');
  if (/[?&]static=1(&|$)/.test(location.search) || cls.contains('shopify-design-mode')) cls.add('bb-static');

  const mq = matchMedia('(prefers-reduced-motion: reduce)');
  const calc = () => mq.matches || cls.contains('bb-static') || cls.contains('shopify-design-mode');
  let reduced = calc();
  mq.addEventListener?.('change', () => { reduced = calc(); });

  const on = (t, ev, fn, o) => t?.addEventListener(ev, fn, o);
  const rand = (a, b) => a + Math.random() * (b - a);
  const later = (fn, ms) => setTimeout(fn, ms);
  const visible = (el) => {
    if (!el?.isConnected) return false;
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight;
  };
  const center = (t) => {
    if (!t) return null;
    if (!(t instanceof Element)) return typeof t.x === 'number' ? { x: t.x, y: t.y } : null;
    const r = t.getBoundingClientRect();
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  };
  const restart = (el, c, ms) => {
    el.classList.remove(c);
    void el.offsetWidth;
    el.classList.add(c);
    clearTimeout(el['_bb' + c]);
    el['_bb' + c] = later(() => el.classList.remove(c), ms);
  };

  /* particles: #bb-fx in <body>, or in the open modal <dialog> (top layer) */
  function fxLayer() {
    let layer = doc.getElementById('bb-fx');
    if (!layer) {
      layer = doc.createElement('div');
      layer.id = 'bb-fx';
      layer.setAttribute('aria-hidden', 'true');
    }
    let host = doc.body;
    try { host = [...doc.querySelectorAll('dialog:modal')].pop() || host; } catch {}
    if (layer.parentNode !== host) host.appendChild(layer);
    return layer;
  }
  function particle(layer, kind, x, y, dx, dy, size, dur, rot) {
    const p = doc.createElement('span');
    p.className = `bb-p bb-${kind}`;
    p.style.cssText = `--x:${x.toFixed(1)}px;--y:${y.toFixed(1)}px;--dx:${dx.toFixed(1)}px;--dy:${dy.toFixed(1)}px;--s:${size}px;--d:${dur}ms;--r:${rot}deg`;
    const done = () => p.remove();
    on(p, 'animationend', done, { once: true });
    later(done, dur + 400);
    layer.appendChild(p);
  }
  /** Bubbles + gold sparkles + the logo's splash pair (target: element or {x, y}) */
  function burst(target, opts = {}) {
    if (reduced) return;
    const o = { bubbles: 6, sparkles: 4, splash: true, spread: 80, ...opts };
    const c = center(target);
    if (!c) return;
    const layer = fxLayer();
    const lr = layer.getBoundingClientRect();
    const x = c.x - lr.left, y = c.y - lr.top;
    const n = o.bubbles + o.sparkles;
    const spread = Math.max(40, Math.min(90, o.spread));
    for (let i = 0; i < n; i++) {
      const bubble = i < o.bubbles;
      const a = (i / n) * Math.PI * 2 + rand(-0.35, 0.35) - Math.PI / 2;
      const d = rand(spread * 0.5, spread);
      particle(layer, bubble ? 'bubble' : 'sparkle', x, y, Math.cos(a) * d, Math.sin(a) * d * 0.85 - rand(8, 22),
        Math.round(bubble ? rand(14, 26) : rand(10, 18)), Math.round(rand(760, 960)), bubble ? 0 : Math.round(rand(-90, 90)));
    }
    if (o.splash) particle(layer, 'splash', x, y, rand(-10, 10), -spread * 0.7, 18, 900, 0);
  }

  const hop = (el) => { if (el && !reduced) restart(el, 'is-hopping', 800); };
  const blink = (el) => { if (el && !reduced) restart(el, 'is-blinking', 140); };
  let live;
  function announce(text) {
    if (!live) {
      live = doc.createElement('div');
      live.className = 'bb-visually-hidden';
      live.setAttribute('role', 'status');
      doc.body.appendChild(live);
    }
    live.textContent = text;
  }
  function say(el, text) {
    if (!el || !text) return;
    el.querySelector(':scope > .bb-say')?.remove();
    const b = doc.createElement('span');
    b.className = 'bb-say';
    b.setAttribute('aria-hidden', 'true');
    b.textContent = text;
    el.appendChild(b);
    const r = el.getBoundingClientRect(), half = b.offsetWidth / 2, cx = r.left + r.width / 2;
    b.style.setProperty('--bb-say-dx', `${Math.round(Math.min(0, innerWidth - 16 - cx - half) || Math.max(0, 16 - cx + half))}px`);
    announce(text);
    later(() => { b.classList.add('is-out'); later(() => b.remove(), reduced ? 0 : 220); }, 2400);
  }
  function hopAll(container, stagger = 90) {
    if (!container || reduced) return;
    container.querySelectorAll('[data-bb-mascot]').forEach((m, i) => later(() => hop(m), i * stagger));
  }

  /* bubble flies to the bag (450ms arc), mini burst + bag squash */
  function flyToBag(fromEl) {
    if (reduced || !fromEl?.isConnected) return Promise.resolve();
    const from = center(fromEl);
    const bag = [...doc.querySelectorAll('.header-actions__cart-icon, [aria-controls="cart-drawer"]')].find(visible) || null;
    const to = bag ? center(bag) : { x: innerWidth - 32, y: 24 };
    const layer = fxLayer();
    const lr = layer.getBoundingClientRect();
    const b = doc.createElement('span');
    b.className = 'bb-bubble bb-bubble--fly';
    layer.appendChild(b);
    const x0 = from.x - lr.left, y0 = from.y - lr.top, x2 = to.x - lr.left, y2 = to.y - lr.top;
    const cx = (x0 + x2) / 2, cy = Math.min(y0, y2) - 120;
    const frames = [];
    for (let i = 0; i <= 12; i++) {
      const t = i / 12, q = (a, b, c) => ((1 - t) ** 2 * a + 2 * (1 - t) * t * b + t * t * c).toFixed(1);
      frames.push({ transform: `translate(${q(x0, cx, x2)}px,${q(y0, cy, y2)}px) scale(${1 - t * 0.35})` });
    }
    return new Promise((resolve) => {
      let done = false;
      const end = () => {
        if (done) return;
        done = true;
        b.remove();
        burst(to, { bubbles: 0, sparkles: 3, spread: 44 });
        if (bag) restart(bag, 'bb-bag-bump', 560);
        resolve();
      };
      try { b.animate(frames, { duration: 450, easing: 'cubic-bezier(.45,0,.55,1)', fill: 'forwards' }).onfinish = end; } catch { end(); }
      later(end, 520);
    });
  }

  function toast(text) {
    if (!text) return;
    doc.querySelector('.bb-toast')?.remove();
    const t = doc.createElement('div');
    t.className = 'bb-toast';
    t.setAttribute('role', 'status');
    t.innerHTML = '<span class="bb-toast__spark" aria-hidden="true"></span>';
    t.append(text);
    doc.body.appendChild(t);
    requestAnimationFrame(() => requestAnimationFrame(() => t.classList.add('is-in')));
    later(() => { t.classList.remove('is-in'); later(() => t.remove(), reduced ? 0 : 320); }, 2600);
  }

  /* reveal once; .is-visible pauses loops off screen; blinks */
  const IO = window.IntersectionObserver;
  const revealIO = IO && new IO((es) => es.forEach((e) => {
    if (!e.isIntersecting) return;
    e.target.classList.add('is-in');
    revealIO.unobserve(e.target);
  }), { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  const surfaceIO = IO && new IO((es) => es.forEach((e) => e.target.classList.toggle('is-visible', e.isIntersecting)), { rootMargin: '80px 0px' });
  const blinkSet = new Set();
  const blinkIO = IO && new IO((es) => { es.forEach((e) => (e.isIntersecting ? blinkSet.add(e.target) : blinkSet.delete(e.target))); blinkRun(); });
  let blinkTimer = 0;
  function blinkRun() {
    const on = blinkSet.size > 0 && !doc.hidden && !reduced;
    if (on && !blinkTimer) {
      blinkTimer = setInterval(() => {
        const pool = [...blinkSet].flatMap((c) => [...c.querySelectorAll('[data-bb-mascot]')]).filter(visible);
        if (pool.length) blink(pool[Math.floor(Math.random() * pool.length)]);
      }, 3200);
    } else if (!on && blinkTimer) {
      clearInterval(blinkTimer);
      blinkTimer = 0;
    }
  }
  on(doc, 'visibilitychange', blinkRun);
  /* .bb-clear patches repeat their surface gradient (bubbo.css) */
  const clearRO = window.ResizeObserver && new ResizeObserver((es) => es.forEach(({ target: s }) => {
    const top = s.getBoundingClientRect().top;
    s.querySelectorAll('.bb-clear').forEach((c) => {
      if (c.closest('.bb-surface') !== s) return;
      c.style.setProperty('--bb-clear-y', `${Math.round(c.getBoundingClientRect().top - top)}px`);
      c.style.setProperty('--bb-surface-h', `${s.offsetHeight}px`);
    });
  }));
  const within = (scope, sel) => [...(scope.matches?.(sel) ? [scope] : []), ...scope.querySelectorAll(sel)];
  function scan(scope = doc) {
    within(scope, '[data-bb-reveal]:not(.is-in)').forEach((el) => (revealIO && !cls.contains('bb-static') ? revealIO.observe(el) : el.classList.add('is-in')));
    if (IO) {
      within(scope, '.bb-surface').forEach((el) => { surfaceIO.observe(el); if (clearRO && el.querySelector('.bb-clear')) clearRO.observe(el); });
      within(scope, '.bb-blinks').forEach((el) => blinkIO.observe(el));
    }
  }
  function unscan(scope) {
    if (!IO || !scope?.querySelectorAll) return;
    within(scope, '[data-bb-reveal], .bb-surface, .bb-blinks').forEach((el) => {
      revealIO.unobserve(el); surfaceIO.unobserve(el); blinkIO.unobserve(el); clearRO?.unobserve(el); blinkSet.delete(el);
    });
    blinkRun();
  }

  /* <bubbo-rail>: snap scroller, prev/next, dots */
  class BubboRail extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.ac = new AbortController();
      const track = this.querySelector('.bb-rail__track');
      if (!track) return;
      const items = [...track.children];
      const dots = this.hasAttribute('data-dots') ? this.querySelector('.bb-rail__dots') : null;
      dots?.replaceChildren(...items.map(() => Object.assign(doc.createElement('span'), { className: 'bb-rail__dot' })));
      const prev = this.querySelector('.bb-rail__prev');
      const next = this.querySelector('.bb-rail__next');
      const step = (dir) => track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.8, 160), behavior: reduced ? 'auto' : 'smooth' });
      on(prev, 'click', () => step(-1), { signal: this.ac.signal });
      on(next, 'click', () => step(1), { signal: this.ac.signal });
      const seen = new Set();
      this.io = new IO((es) => {
        es.forEach((e) => (e.isIntersecting ? seen.add(e.target) : seen.delete(e.target)));
        const first = items.findIndex((it) => seen.has(it));
        dots && [...dots.children].forEach((d, i) => d.classList.toggle('is-active', i === Math.max(first, 0)));
        if (prev) prev.disabled = seen.has(items[0]);
        if (next) next.disabled = seen.has(items[items.length - 1]);
      }, { root: track, threshold: 0.6 });
      items.forEach((it) => this.io.observe(it));
      this.ro = new ResizeObserver(() => this.toggleAttribute('data-overflow', track.scrollWidth > track.clientWidth + 2));
      this.ro.observe(track);
    }
    disconnectedCallback() { this.ac?.abort(); this.io?.disconnect(); this.ro?.disconnect(); }
  }

  /* <bubbo-tabs>: sliding pill, arrows/Home/End */
  class BubboTabs extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.ac = new AbortController();
      const sig = { signal: this.ac.signal };
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      if (!this.tabs.length) return;
      this.pill = this.querySelector('.bb-tabs__pill');
      this.select(this.tabs.find((t) => t.getAttribute('aria-selected') === 'true') || this.tabs[0], false);
      this.tabs.forEach((t) => on(t, 'click', () => this.select(t, true), sig));
      on(this.querySelector('[role="tablist"]'), 'keydown', (e) => {
        const i = this.tabs.indexOf(doc.activeElement);
        const to = { ArrowRight: i + 1, ArrowDown: i + 1, ArrowLeft: i - 1, ArrowUp: i - 1, Home: 0, End: this.tabs.length - 1 }[e.key];
        if (i < 0 || to === undefined) return;
        e.preventDefault();
        const tab = this.tabs[(to + this.tabs.length) % this.tabs.length];
        this.select(tab, true);
        tab.focus();
      }, sig);
      this.ro = new ResizeObserver(() => this.place());
      this.ro.observe(this);
      this.classList.add('is-ready');
    }
    disconnectedCallback() { this.ac?.abort(); this.ro?.disconnect(); }
    select(tab, user) {
      this.tabs.forEach((t) => {
        const on = t === tab;
        const was = t.getAttribute('aria-selected') === 'true';
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const panel = doc.getElementById(t.getAttribute('aria-controls') || '');
        if (!panel) return;
        panel.hidden = !on;
        if (on && !was && user && !reduced) restart(panel, 'is-entering', 320);
      });
      this.active = tab;
      this.place();
    }
    place() {
      if (!this.pill || !this.active) return;
      this.pill.style.setProperty('--bb-pill-x', `${this.active.offsetLeft}px`);
      this.pill.style.setProperty('--bb-pill-w', `${this.active.offsetWidth}px`);
    }
  }

  /* <bubbo-variant-aware data-key>: re-renders from the variant-change page (horizon-map 4.4) */
  class BubboVariantAware extends HTMLElement {
    connectedCallback() {
      this.ac?.abort();
      this.ac = new AbortController();
      on(this.closest('.shopify-section'), EV_SELECT, (event) => {
        if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
        event.promise?.then(({ detail }) => {
          const fresh = detail?.html?.querySelector(`bubbo-variant-aware[data-key="${CSS.escape(this.dataset.key || '')}"]`);
          if (fresh) this.replaceChildren(...Array.from(fresh.childNodes, (n) => n.cloneNode(true)));
        }).catch(() => {});
      }, { signal: this.ac.signal });
    }
    disconnectedCallback() { this.ac?.abort(); }
  }
  [['bubbo-rail', BubboRail], ['bubbo-tabs', BubboTabs], ['bubbo-variant-aware', BubboVariantAware]]
    .forEach(([n, c]) => customElements.get(n) || customElements.define(n, c));

  /* tap a mascot: hop + blink + say + 4 sparkles */
  on(doc, 'click', (e) => {
    const m = e.target instanceof Element && e.target.closest('[data-bb-tap]');
    if (!m) return;
    hop(m);
    blink(m);
    say(m, m.dataset.bbSay);
    burst(m, { bubbles: 0, sparkles: 4, splash: false, spread: 60 });
  });

  /* magic moment: add to bag -> "Yay! In your bag" -> burst -> flight -> drawer (<= 600ms) */
  let lastAdd = null;
  let lastOpener = null;
  const addButtons = () => [...doc.querySelectorAll('.add-to-cart-button')];
  on(doc, 'click', (e) => {
    const btn = e.target instanceof Element && e.target.closest('.add-to-cart-button');
    if (!btn) return;
    lastAdd = { el: btn, id: btn.id, index: addButtons().indexOf(btn), time: Date.now() };
    if (btn.classList.contains('quick-add__button--choose')) lastOpener = btn;
  }, true);
  /* Horizon may morph the button: find it again by id, else by index */
  const relocate = (src) => (!src ? null : src.el?.isConnected ? src.el : src.id ? doc.getElementById(src.id) : addButtons()[src.index] || null);
  let ctx;
  function yay(btn) {
    const label = getComputedStyle(root).getPropertyValue('--bb-added-label').trim().replace(/^["']|["']$/g, '');
    try {
      ctx ||= doc.createElement('canvas').getContext('2d');
      ctx.font = getComputedStyle(btn).font;
      btn.classList.toggle('bb-yay--icon', ctx.measureText(label).width > btn.clientWidth - 20);
    } catch {}
    btn.classList.add('bb-yay');
    clearTimeout(btn._bbYay);
    btn._bbYay = later(() => btn.classList.remove('bb-yay', 'bb-yay--icon'), 1600);
  }
  async function celebrate(src, event) {
    let btn = relocate(src);
    const modal = (btn || (event.target instanceof Element ? event.target : null))?.closest?.('dialog');
    /* mascot: card around the button, else the section's PDP mascot, else the modal opener's card */
    const keyOf = (el) => el?.closest?.('[data-bb-mascot], [data-bb-pdp-mascot]') || el?.closest?.('.shopify-section')?.querySelector('[data-bb-pdp-mascot]');
    const keyEl = (modal ? keyOf(lastOpener) : null) || keyOf(btn);
    const detail = {
      variantId: String(event.lines?.[0]?.merchandiseId || '').split('/').pop() || null,
      productId: event.target?.dataset?.productId || btn?.closest('[data-product-id]')?.dataset.productId || null,
      mascotKey: keyEl ? keyEl.dataset.bbMascot || keyEl.dataset.bbPdpMascot || null : null,
    };
    let opened = false;
    const finish = () => {
      if (opened) return;
      opened = true;
      try { doc.querySelector('theme-drawer#cart-drawer')?.open?.(); } catch {}
      doc.dispatchEvent(new CustomEvent('bubbo:added', { detail }));
    };
    if (btn) yay(btn);
    if (modal?.open) {
      /* quick-add modal closes on success: open the drawer after its close event */
      await new Promise((r) => { on(modal, 'close', r, { once: true }); later(r, 1200); });
      btn = visible(lastOpener) ? lastOpener : null;
    }
    const guard = later(finish, 600);
    try {
      if (!reduced && visible(btn)) {
        burst(btn);
        await flyToBag(btn);
      }
    } catch {} finally {
      clearTimeout(guard);
      finish();
    }
  }
  on(doc, EV_LINES, (event) => {
    if (event.action !== 'add' || !event.promise) return;
    const src = lastAdd && Date.now() - lastAdd.time < 15000 ? lastAdd : null;
    lastAdd = null;
    event.promise.then((res) => (res?.detail?.didError ? null : celebrate(src, event))).catch(() => {});
  });

  on(doc, 'shopify:section:load', (e) => scan(e.target));
  on(doc, 'shopify:section:unload', (e) => unscan(e.target));

  window.Bubbo = { get reducedMotion() { return reduced; }, burst, hop, blink, say, hopAll, flyToBag, toast };
  const init = () => {
    if (IO) cls.add('bb-io', 'bb-reveal-ready');
    scan(doc);
  };
  if (doc.readyState === 'loading') on(doc, 'DOMContentLoaded', init, { once: true });
  else init();
})();
